import { get } from "@/shared/api"
import { API_ENDPOINTS } from "@/shared/api/endpoints"

import type { Currency } from "./types"

interface CurrencyDTO {
  currencyId: number
  currencyCode: string
  currencyName: string
  symbol: string
  decimalPlaces: number
  baseCurrency: "Y" | "N"
  roundingRule: string
  roundingPrecision: number
  formatMask: string
  symbolPosition: "BEFORE" | "AFTER"
  erpCurrencyCode: string
  enableFlag: "Y" | "N"
  effectiveStartDate: string
  effectiveEndDate: string | null
}

function mapCurrency(dto: CurrencyDTO): Currency {
  return {
    currencyId: dto.currencyId,
    currencyCode: dto.currencyCode,
    currencyName: dto.currencyName,
    symbol: dto.symbol,
    decimalPlaces: dto.decimalPlaces,
    baseCurrency: dto.baseCurrency === "Y",
    roundingRule: dto.roundingRule,
    roundingPrecision: dto.roundingPrecision,
    formatMask: dto.formatMask,
    symbolPosition: dto.symbolPosition,
    erpCurrencyCode: dto.erpCurrencyCode,
    enableFlag: dto.enableFlag === "Y",
    effectiveStartDate: dto.effectiveStartDate,
    effectiveEndDate: dto.effectiveEndDate,
  }
}

export const currencyService = {
  index: async (): Promise<Currency[]> => {
    const response = await get<CurrencyDTO[]>(API_ENDPOINTS.CURRENCIES)
    const items = response.data
    return Array.isArray(items) ? items.map(mapCurrency) : []
  },
}
